<template>
    <div class="n-files-list" ref="filesList">
        <slot name="list-items">
            <p class="n-files-list__empty" v-if="showSlot('list-empty') && fileList.length === 0"><slot name="list-empty">No files uploaded yet.</slot></p>

            <ul class="n-files-list__list" v-else>
                <li class="n-files-list__item" v-for="file in fileList" :id="'file-' + file.id" :data-mimetype="file.contentType" :key="file.id">
                    <div class="n-files-list__item-image">
                        <img :src="file.dataSource" width="120" alt="" :title="file.name" loading="lazy" v-if="file.contentType.indexOf('image') > -1 && (file.contentType.indexOf('webp') > -1 || file.contentType.indexOf('jpeg') > -1 || file.contentType.indexOf('png') > -1 || file.contentType.indexOf('gif') > -1)" />
                        <img :src="'/assets/images/' + showIcon(file.contentType)" width="120" alt="" :title="file.name" loading="lazy" v-else />
                    </div>

                    <div class="n-files-list__item-info">
                        <div class="n-files-list__item-name" :title="file.name">{{ file.name }}</div>
                        <div class="n-files-list__item-actions">
                            <a :href="file.dataSource" target="_blank" class="n-files-list__item-action n-files-list__item-action--open" v-if="showSlot('list-item-open')" @click.prevent="openFile(file)"><slot name="list-item-open">Open</slot></a>
                            <a :href="file.dataSource" download class="n-files-list__item-action n-files-list__item-action--download" v-if="showSlot('list-item-download')"><slot name="list-item-download">Download</slot></a>
                            <button class="n-files-list__item-action n-files-list__item-action--replace" v-if="showSlot('list-item-replace')" @click="replaceFile(file)"><slot name="list-item-replace">Replace</slot></button>
                            <button class="n-files-list__item-action n-files-list__item-action--delete" v-if="showSlot('list-item-delete')" @click="deleteFile(file)"><slot name="list-item-delete">Delete</slot></button>
                        </div>
                    </div>
                </li>
            </ul>
        </slot>
    </div>
</template>

<script>
export default {
    name: 'NFilesList',
    props: {
        fileList: Array
    },
    data: function () {
        return {
        }
    },
    computed: {
    },
    watch: {
    },
    methods: {
        showSlot (slotName) {
            if (this.$slots.hasOwnProperty(slotName) && this.$slots[slotName] === undefined) {
                return false
            }

            return true
        },
        showIcon (mimeType) {
            // Determine icon by mime type
            let iconName = 'unknown.svg'

            if (mimeType.indexOf('pdf') > -1) {
                iconName = 'pdf.svg'
            } else if (mimeType.indexOf('officedocument') > -1 && mimeType.indexOf('.document') > -1) {
                iconName = 'doc.svg'
            } else if (mimeType.indexOf('officedocument') > -1 && mimeType.indexOf('.presentation') > -1) {
                iconName = 'ppt.svg'
            } else if (mimeType.indexOf('officedocument') > -1 && mimeType.indexOf('.sheet') > -1) {
                iconName = 'xls.svg'
            } else if (mimeType.indexOf('csv') > -1) {
                iconName = 'csv.svg'
            } else if (mimeType.indexOf('plain') > -1) {
                iconName = 'txt.svg'
            } else if (mimeType.indexOf('xml') > -1) {
                iconName = 'xml.svg'
            }

            return iconName
        },
        openFile (file) {
            // Send the file being opened
            this.$emit('openFile', file)
        },
        replaceFile (file) {
            // Send the file being replaced
            this.$emit('replaceFile', file)
        },
        deleteFile (file) {
            // Send the file being deleted
            this.$emit('deleteFile', file)
        }
    },
    created: function () {
    },
    mounted: function () {
    }
}
</script>

<style lang="scss">
@import '../../../scss/utils/colors.scss';

.n-files-list__empty {
    font-style: italic;
}

.n-files-list__list {
    display: grid;
    grid-gap: 24px;
    grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
    list-style: none;
    margin-bottom: 2em;
    margin-top: 2em;
    padding-left: 0;
}
.n-files-list__item {
    background: #f6f6f6;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    padding: 1em;
}
.n-files-list__item-image {
    align-items: center;
    display: flex;
    height: 100%;
    justify-content: center;
}
.n-files-list__item-info {
    border-top: 1px solid $dark-gray;
    margin-top: 1em;
    padding-top: 1em;
}
.n-files-list__item-name {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    width: 100%;
}
.n-files-list__item-actions {
    border-top: 1px solid $dark-gray;
    display: grid;
    gap: 6px;
    grid-template-columns: repeat(auto-fit, minmax(60px, 1fr));
    margin-top: 1em;
    padding-top: 1em;
}
.n-files-list__item-action {
    background: none;
    border: 2px solid lighten($button-blue, 20%);
    border-radius: 4px;
    box-shadow: 0px 3px 1px -2px rgba(0, 0, 0, 0.20), 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 1px 5px 0px rgba(0, 0, 0, 0.12);
    color: $button-blue;
    cursor: pointer;
    display: inline-block;
    filter: grayscale(0.8);
    font-size: 0.8em;
    font-weight: 500;
    line-height: 1.25em;
    outline-offset: 4px;
    padding: 8px 16px;
    text-align: center;
    text-decoration: none;
    transition: background-color 0.15s var(--ease-in-out-cubic), border-color 0.15s var(--ease-in-out-cubic), box-shadow 0.3s cubic-bezier(0.4, 0, 0.2, 1), filter 0.15s var(--ease-in-out-cubic);
    white-space: nowrap;
}
.n-files-list__item-action:focus,
.n-files-list__item-action:hover {
    background-color: lighten($button-blue, 53%); // 57 = white
    box-shadow: 0px 2px 4px -1px rgba(0, 0, 0, 0.20), 0px 4px 5px 0px rgba(0, 0, 0, 0.14), 0px 1px 10px 0px rgba(0, 0, 0, 0.12);
    color: currentColor;
    filter: none;
}
.n-files-list__item-action:active {
    background-color: lighten($button-blue, 49%);
    box-shadow: 0px 5px 5px -3px rgba(0, 0, 0, 0.20), 0px 8px 10px 1px rgba(0, 0, 0, 0.14), 0px 3px 14px 2px rgba(0, 0, 0, 0.12);
    transform: inherit;
}
.n-files-list__item-action--download {
    border-color: $button-green;
}
.n-files-list__item-action--download:focus,
.n-files-list__item-action--download:hover {
    background-color: lighten($button-green, 64%); // 68 = white
}
.n-files-list__item-action--download:active {
    background-color: lighten($button-green, 60%);
}
.n-files-list__item-action--replace {
    border-color: $button-orange;
}
.n-files-list__item-action--replace:focus,
.n-files-list__item-action--replace:hover {
    background-color: lighten($button-orange, 39%); // 43 = white
}
.n-files-list__item-action--replace:active {
    background-color: lighten($button-orange, 35%);
}
.n-files-list__item-action--delete {
    border-color: $button-red;
}
.n-files-list__item-action--delete:focus,
.n-files-list__item-action--delete:hover {
    background-color: lighten($button-red, 51%); // 55 = white
}
.n-files-list__item-action--delete:active {
    background-color: lighten($button-red, 47%);
}
</style>



// WEBPACK FOOTER //
// src/components/shared/files/files-list.vue